import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { DimensionRestrictionDTO } from '@dto';
import { SearchFilterDropDownConfig } from '../search-filter-item.vo';
import { ReplaySubject, Subject, takeUntil, tap } from 'rxjs';
import { logger } from '@logging';
import { map } from 'rxjs/operators';

@Component({
  selector: 'jumbo-search-filter-drop-down-item',
  templateUrl: './search-filter-drop-down-item.component.html',
  styleUrls: ['./search-filter-drop-down-item.component.scss']
})
export class SearchFilterDropDownItemComponent implements AfterViewInit, OnDestroy {

  private destroy$: Subject<any> = new Subject<any>();
  private configChange$: Subject<any> = new Subject<any>();
  private loadRestriction$: ReplaySubject<DimensionRestrictionDTO> = new ReplaySubject<DimensionRestrictionDTO>();

  get config(): SearchFilterDropDownConfig {
    return this._config;
  }

  @Input()
  set config(value: SearchFilterDropDownConfig) {
    this.configChange$.next(true);
    this._config = value;
    this.changeDetectorRef.detectChanges();
    this.selectedItem = value.options[value.defaultSelectedIndex].itemValue;
    this._config.restrictionToLoad$.pipe(
        takeUntil(this.destroy$),
        takeUntil(this.configChange$)
    ).subscribe(restriction =>this.loadRestriction$.next(restriction))
  }

  private _config: SearchFilterDropDownConfig;

  @Output()
  public restrictionChange: EventEmitter<DimensionRestrictionDTO> = new EventEmitter<DimensionRestrictionDTO>();

  public selectedItem: any;

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnDestroy(): void {
      this.destroy$.next(true);
  }

  ngAfterViewInit(): void {
    this.loadRestriction$.pipe(
        takeUntil(this.destroy$),
        map(restriction => this.loadRestriction(restriction)),
        tap(() => this.emitNewRestriction())
    ).subscribe();
    this.emitNewRestriction();
  }

  selectionChange() {
    this.emitNewRestriction();
  }

  emitNewRestriction() {
    this.restrictionChange.next( this.config.buildRestriction(this.selectedItem, this.selectedItem) );
  }

  private loadRestriction(restriction: DimensionRestrictionDTO) {
    const item = this.config.options.find(
        candidate => candidate.itemValue?
            (candidate.itemValue).toString():
            'null' === restriction.serialisedRestrictionValue);
    if (!item) {
      logger.warn(`Cannot select item ${restriction.restrictionValue}`);
      return;
    }
    this.selectedItem = item.itemValue;
    this.changeDetectorRef.detectChanges();
  }
}
